export const ROUTE_LOGIN = "/login";
export const ROUTE_AUTH_CALLBACK = "/auth/callback/*";

export const ROUTE_ADMIN = "/admin";
export const ROUTE_ADMIN_BASE = `${ROUTE_ADMIN}/*`;

export const ROUTE_DASHBOARD = `${ROUTE_ADMIN}/dashboard`;
export const ROUTE_USERS = `${ROUTE_ADMIN}/users`;
export const ROUTE_USER_DETAIL = `${ROUTE_USERS}/:userId`;
export const ROUTE_USER_DETAIL_PATTERN = `${ROUTE_USERS}/:userId/*`;
export const ROUTE_KYC = `${ROUTE_ADMIN}/kyc`;
export const ROUTE_WAITING_LIST = `${ROUTE_ADMIN}/waiting-list-users`;
export const ROUTE_PRESALE_ORDERS = `${ROUTE_ADMIN}/presale-orders`;
export const ROUTE_PRESALE_USERS = `${ROUTE_ADMIN}/presale-users`;
export const ROUTE_PRESALE_TOKEN = `${ROUTE_ADMIN}/presale-token`;
export const ROUTE_CRON_JOBS = `${ROUTE_ADMIN}/cron-jobs`;
export const ROUTE_BANK_ACCOUNT = `${ROUTE_ADMIN}/bank-account`;
export const ROUTE_TRANSACTIONS = `${ROUTE_ADMIN}/transactions`;
export const ROUTE_ORDERS = `${ROUTE_ADMIN}/orders`;
export const ROUTE_WITHDRAW = `${ROUTE_ADMIN}/withdraw`;
export const ROUTE_WALLETS = `${ROUTE_ADMIN}/wallets`;
export const ROUTE_DEPOSIT = `${ROUTE_ADMIN}/deposit`;
export const ROUTE_SETTINGS = `${ROUTE_ADMIN}/settings`;
export const ROUTE_REFERRALS = `${ROUTE_ADMIN}/referrals`;
export const ROUTE_SUPPORT = `${ROUTE_ADMIN}/support`;
export const ROUTE_LOGS = `${ROUTE_ADMIN}/logs`;
export const ROUTE_NOTIFICATIONS = `${ROUTE_ADMIN}/notifications`;

export const ROUTE_MANAGEMENT = `${ROUTE_ADMIN}/management`;
export const ROUTE_MANAGEMENT_ADMINS = `${ROUTE_MANAGEMENT}/admins`;
export const ROUTE_MANAGEMENT_ROLES = `${ROUTE_MANAGEMENT}/roles`;
export const ROUTE_MANAGEMENT_PERMISSIONS = `${ROUTE_MANAGEMENT}/permissions`;

